/*
#*===================================================================
#*
#* Licensed Materials - Property of Zuum Transportation Inc.
#*
#* Copyright Zuum 2015-2021. All Rights Reserved.
#*
#*===================================================================
*/

import { createAction, props } from '@ngrx/store';

import { MongoUser } from '@core/models/mongo';

export const loadUser = createAction('[Settings:Account] Load user data');
export const loadUserSuccess = createAction('[Settings:Account] Load user data success', props<{ user: MongoUser }>());
export const loadUserFailure = createAction(
  '[Settings:Account] Load user data failure',
  props<{ errorMessage: string }>()
);
export const updateUser = createAction('[Settings:Account] Update user', props<{ user: Partial<MongoUser> }>());
export const updateUserSuccess = createAction('[Settings:Account] Update user success', props<{ user: MongoUser }>());
export const updateUserFailure = createAction(
  '[Settings:Account] Update user failure',
  props<{ errorMessage: string }>()
);
export const updatePassword = createAction('[Settings:Account] Update password', props<{ user: Partial<MongoUser> }>());
export const updatePasswordSuccess = createAction('[Settings:Account] Update password success', props<{ user: MongoUser }>());
export const updatePasswordFailure = createAction(
  '[Settings:Account] Update password failure',
  props<{ errorMessage: string }>()
);
export const updateUserProfilePicture = createAction(
  '[Settings:Account] Update user profile picture',
  props<{ picture: File; user: MongoUser }>()
);
export const updateUserProfilePictureSuccess = createAction(
  '[Settings:Account] Update user profile picture success',
  props<{ url_s: string; user: MongoUser }>()
);
export const updateUserProfilePictureFailure = createAction(
  '[Settings:Account] Update user profile picture failure',
  props<{ errorMessage: string }>()
);
export const removeProfilePictureWhenUserNotUpdated = createAction(
  '[Settings:Account] Remove Profile picture when user not updated',
  props<{ url_s: string | undefined; user?: MongoUser }>()
);
